import LatestBails from 'components/home/LatestBails'
import { useNavigate } from 'react-router-dom'

import { i18n } from '../i18n'

const CameraPlusIcon = () => (
  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.5 4h-5L7 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
    <path d="M16 5h6" />
    <path d="M19 2v6" />
  </svg>
)
const UserCheckIcon = () => (
  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M16 11l2 2 4-4" />
  </svg>
)
const CheckDocumentIcon = () => (
  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
)
const RouteIcon = () => (
  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="19" r="3" />
    <path d="M9 19h8.5a3.5 3.5 0 000-7h-11a3.5 3.5 0 010-7H15" />
    <circle cx="18" cy="5" r="3" />
  </svg>
)
const PeopleIcon = () => (
  <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
  </svg>
)
const PencilIcon = () => (
  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm2.92 2.33H5v-.92L14.06 6.5l.92.92L5.92 19.58zM20.71 7.04a1 1 0 000-1.41L18.37 3.3a1 1 0 00-1.41 0l-1.34 1.34 3.75 3.75 1.34-1.35z" />
  </svg>
)
const ArrowRight = () => (
  <svg className="w-4 h-4 inline ml-1" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
  </svg>
)

const QualifiedShieldIcon = () => (
  <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z" fill="#0056D2"/>
    <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const Home = () => {
  const navigate = useNavigate()

  const tagQuebec = i18n.translate('home.availableQuebec')
  const navTakeOver = i18n.translate('home.takeOverLease')
  const heroLine1 = i18n.translate('home.heroTitle1')
  const heroLine2 = i18n.translate('home.heroTitle2')
  const heroSubtext = i18n.translate('home.heroSubtext')
  const btnTestNow = i18n.translate('home.testNow')
  const btnSeeHow = i18n.translate('home.seeHowItWorks')
  const qualifiedAd = i18n.translate('home.qualifiedAd')
  const verifiedBy = i18n.translate('home.verifiedBy')
  const rentLabel = i18n.translate('home.rent')
  const rentPrice = i18n.translate('home.rentPrice')
  const qualifiedAdAlt = i18n.translate('home.qualifiedAdImageAlt')
  const howWeDoIt = i18n.translate('home.howWeDoIt')
  const step1Title = i18n.translate('home.step1Title')
  const step1Desc = i18n.translate('home.step1Desc')
  const step2Title = i18n.translate('home.step2Title')
  const step2Desc = i18n.translate('home.step2Desc')
  const step3Title = i18n.translate('home.step3Title')
  const step3Desc = i18n.translate('home.step3Desc')
  const preQual = i18n.translate('home.preQualification')
  const protectedContacts = i18n.translate('home.protectedContacts')
  const photosRequired = i18n.translate('home.photosRequired')
  const readyToTransfer = i18n.translate('home.readyToTransfer')
  const ctaSubtext = i18n.translate('home.ctaSubtext')
  const transferNow = i18n.translate('home.transferNow')

  return (
    <div className="min-h-screen bg-imovWhiteShadow">
      {/* Hero */}
      <section className="bg-imovWhiteShadow py-12 md:py-20">
        <div className="max-w-6xl mx-auto px-4 flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-100 border border-blue-300 text-gray-700 text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-imovPrimary" />
              {tagQuebec}
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-5">
              <span className="text-gray-900">{heroLine1}</span>
              <br />
              <span className="text-[#0056D2]">{heroLine2}</span>
            </h1>
            <p className="text-gray-600 text-base md:text-lg mb-8 max-w-xl">
              {heroSubtext}
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                type="button"
                onClick={() => navigate('/create-ad', { state: { newListing: true } })}
                className="px-6 py-3 rounded-lg bg-[#0056D2] text-white font-semibold hover:bg-[#0046b3] transition-colors inline-flex items-center"
              >
                {btnTestNow}
                <ArrowRight />
              </button>
              <button
                type="button"
                onClick={() => navigate('/listings')}
                className="px-6 py-3 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors"
              >
                {btnSeeHow}
              </button>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md">
            <div className="rounded-2xl bg-white shadow-lg overflow-hidden border border-gray-100">
              <div className="aspect-[4/3] bg-gray-200 overflow-hidden">
                <img
                  src="/imgs/houseInterior1.jpeg"
                  alt={qualifiedAdAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-5 flex justify-between items-end gap-4">
                <div className="flex items-start gap-3">
                  <QualifiedShieldIcon />
                  <div>
                    <p className="text-gray-800 font-medium text-sm">{qualifiedAd}</p>
                    <p className="text-gray-500 text-xs mt-0.5">{verifiedBy}</p>
                  </div>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-gray-400 text-xs uppercase tracking-wide font-medium">{rentLabel}</p>
                  <p className="text-[#0056D2] font-bold text-xl">{rentPrice}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="comment-ca-marche" className="bg-imovWhite py-16">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-center text-2xl md:text-3xl font-bold text-imovSecondary mb-12">
            {howWeDoIt}
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                num: 1,
                icon: <PencilIcon />,
                color: 'text-imovPrimary',
                title: step1Title,
                desc: step1Desc,
              },
              {
                num: 2,
                icon: <CheckDocumentIcon />,
                color: 'text-imovPrimary',
                title: step2Title,
                desc: step2Desc,
              },
              {
                num: 3,
                icon: <PeopleIcon />,
                color: 'text-imovPrimary',
                title: step3Title,
                desc: step3Desc,
              },
            ].map((step) => (
              <div
                key={step.num}
                className="relative bg-imovWhiteShadow rounded-2xl p-6 border border-imovGray/30"
              >
                <span className="absolute top-4 right-4 text-6xl font-bold text-imovGray/40">
                  {step.num}
                </span>
                <div className={`mb-4 ${step.color}`}>{step.icon}</div>
                <h3 className="text-lg font-bold text-imovSecondary mb-2">
                  {step.title}
                </h3>
                <p className="text-imovSecondary/80 text-sm leading-relaxed">
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="bg-imovWhiteShadow py-12">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center gap-3">
              <span className="text-imovPrimary">
                <UserCheckIcon />
              </span>
              <span className="font-semibold text-imovSecondary">
                {preQual}
              </span>
            </div>
            <div className="flex flex-col items-center gap-3">
              <span className="text-imovPrimary">
                <RouteIcon />
              </span>
              <span className="font-semibold text-imovSecondary">
                {protectedContacts}
              </span>
            </div>
            <div className="flex flex-col items-center gap-3">
              <span className="text-imovPrimary">
                <CameraPlusIcon />
              </span>
              <span className="font-semibold text-imovSecondary">
                {photosRequired}
              </span>
            </div>
          </div>
        </div>
      </section>

      <div className="w-full border-t border-imovGray/20" />

      <LatestBails />

      {/* CTA Banner */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto bg-imovPrimary rounded-2xl p-10 md:p-14 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-imovWhite mb-3">
            {readyToTransfer}
          </h2>
          <p className="text-imovWhite/90 mb-8">
            {ctaSubtext}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              type="button"
              onClick={() => navigate('/create-ad', { state: { newListing: true } })}
              className="px-6 py-3 rounded-lg bg-imovWhite text-imovPrimary font-semibold hover:bg-imovWhiteShadow transition-colors"
            >
              {transferNow}
            </button>
            <button
              type="button"
              onClick={() => navigate('/listings')}
              className="px-6 py-3 rounded-lg border-2 border-imovWhite text-imovWhite font-semibold hover:bg-imovWhite/10 transition-colors"
            >
              {navTakeOver}
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
